import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/GlassCard.css';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: string;
  floatAnimation?: boolean;
  floatDelay?: number;
}

const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className = '',
  padding = 'var(--space-5)',
  floatAnimation = false,
  floatDelay = 0,
}) => {
  return (
    <motion.div
      className={`glass-card glass-inner-glow glass-card__root ${className}`}
      style={{ padding }}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: floatDelay * 0.1, ease: 'easeOut' }}
      whileHover={{ y: -2 }}
    >
      {floatAnimation && (
        <motion.div
          className="glass-card__float-overlay"
          animate={{ y: [0, -3, 0] }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: floatDelay * 0.3,
          }}
        />
      )}
      {children}
    </motion.div>
  );
};

export default React.memo(GlassCard);
